<script>
  import {getContext} from 'svelte';
  import lang from '../KolExclusiveRegister.lang';

  const LG = getContext('LG');

  const terms = [LG(lang.Terms_1), LG(lang.Terms_2), LG(lang.Terms_3), LG(lang.Terms_4)];

</script>

<style>
  .conditions {
    display: flex;
    flex-direction: column;
    margin-top: 24px;
    border-radius: 20px;
    padding: 20px;
    background: #38393d;
    gap: 12px;
  }
  .conditions li {
    position: relative;
    display: flex;
    padding-left: 24px;
    line-height: 18px;
  }
  .conditions li:before {
    position: absolute;
    left: 5px;
    font-size: 36px;
    content: '·';
  }
</style>

<ul class="conditions">
  {#each terms as term}
    <li class="f14">{term}</li>
  {/each}
</ul>
